import { useUOM } from '../contexts/UOMContext';

export const useFieldLabels = () => {
  const { getFieldLabel } = useUOM();

  return {
    getPowerLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'power'),
    getTemperatureLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'temperature'),
    getLengthLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'length'),
    getAreaLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'area'),
    getVolumeLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'volume'),
    getWeightLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'weight'),
    getPressureLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'pressure'),
    getFlowLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'flow'),
    getGeneralLabel: (baseLabel: string) => getFieldLabel(baseLabel, 'general'),
  };
};
